(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('.disclosure__button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
        flagsList: this.querySelector('.market-flags'),
        flagsTrigger: this.querySelector('.market-flag--trigger')
      };
      if (this.elements.button) {
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      }
      if (this.elements.flagsTrigger && this.elements.flagsList) {
        this.elements.flagsTrigger.addEventListener('click', this.toggleFlags.bind(this));
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        document.addEventListener('click', this.handleOutsideClick);
      }

      this.querySelectorAll('a[data-value]').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    toggleFlags(event) {
      event.preventDefault();
      event.stopPropagation();
      const isOpen = this.elements.flagsList.getAttribute('data-expanded') === 'true';
      this.elements.flagsList.setAttribute('data-expanded', String(!isOpen));
      this.elements.flagsTrigger.setAttribute('aria-expanded', String(!isOpen));
    }

    handleOutsideClick(event) {
      if (!this.contains(event.target) && this.elements.flagsList) {
        this.elements.flagsList.setAttribute('data-expanded', 'false');
        if (this.elements.flagsTrigger) {
          this.elements.flagsTrigger.setAttribute('aria-expanded', 'false');
        }
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const getpagi = document.querySelector('.AjaxinatePagination');
  if(typeof(getpagi) !== "undefined" && getpagi !== null){
    document.addEventListener("DOMContentLoaded", function() {
      const elem = getpagi.getAttribute('data-pagination');
      var endlessScroll = new Ajaxinate({
        container: '.AjaxinateLoop',
        pagination: '.AjaxinatePagination',
        loadingText: '<span class="loader-line"></span>',
        method: elem == 'scroll' ? 'scroll' : 'click'
      });
    });
  }

  /* Mobile drawer: close via the "View Results" button */
  document.addEventListener('DOMContentLoaded', function() {
    var applyBtn = document.querySelector('.era-drawer__apply');
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        var details = applyBtn.closest('details');
        if (details) {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
          document.body.classList.remove('overflow-hidden-mobile');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            jdgm.customizeBadges();
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);

// Experimenting

(function() {
  'use strict';
  
  console.log('🎨 Color Product Switcher: Script loaded');
  
  // Initialize color product switcher
  function initColorProductSwitcher() {
    const colorProductLinks = document.querySelectorAll('.color-product-link');
    const switcher = document.querySelector('.color-products-switcher');
    
    console.log('🎨 Found', colorProductLinks.length, 'color product links');
    
    if (colorProductLinks.length === 0) {
      console.log('🎨 No color product links found, exiting');
      return;
    }
    
    // Get size option position
    const sizeOptionPosition = switcher ? parseInt(switcher.getAttribute('data-size-option-position')) : 0;
    console.log('🎨 Size option position:', sizeOptionPosition);
    
    // Function to get currently selected size
    function getCurrentSize() {
      // Try to find selected size from radio buttons
      const sizeInputs = document.querySelectorAll('input[name*="size" i]:checked, input.single-option-selector__radio:checked');
      
      for (let input of sizeInputs) {
        const name = input.getAttribute('name') || '';
        if (name.toLowerCase().includes('size')) {
          const size = input.value;
          console.log('🎨 Found selected size from radio:', size);
          return size;
        }
      }
      
      // Try to get from variant select dropdown
      const variantSelect = document.querySelector('select[name="id"]');
      if (variantSelect) {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const variantTitle = selectedOption.text;
        
        // Extract size from variant title (format: "Color / Size")
        const parts = variantTitle.split('/');
        if (parts.length >= sizeOptionPosition && sizeOptionPosition > 0) {
          const size = parts[sizeOptionPosition - 1].trim();
          console.log('🎨 Found selected size from dropdown:', size);
          return size;
        }
      }
      
      console.log('🎨 No size found, will use first available');
      return null;
    }
    
    // Function to navigate to product with matching size
    function navigateToProductWithSize(targetUrl, variantMapJSON) {
      const currentSize = getCurrentSize();
      targetUrl = window.StrveAttribution.url(targetUrl);
      
      console.log('🎨 Current size:', currentSize);
      console.log('🎨 Target URL:', targetUrl);
      console.log('🎨 Variant map:', variantMapJSON);
      
      if (!currentSize || !variantMapJSON) {
        // No size selected or no variant map, just go to product
        console.log('🎨 No size or variant map, navigating to base URL');
        window.location.href = targetUrl;
        return;
      }
      
      try {
        // Parse the variant map
        const variantMap = JSON.parse(variantMapJSON);
        console.log('🎨 Parsed variant map:', variantMap);
        
        // Find matching variant ID for the selected size
        const variantId = variantMap[currentSize];
        
        if (variantId) {
          // Navigate to specific variant
          const destination = new URL(targetUrl);
          destination.searchParams.set('variant', variantId);
          const urlWithVariant = destination.href;
          console.log('🎨 Navigating to:', urlWithVariant);
          window.location.href = urlWithVariant;
        } else {
          // Size not available in target product, go to base URL
          console.log('🎨 Size not available in target, navigating to base URL');
          window.location.href = targetUrl;
        }
      } catch (e) {
        console.error('🎨 Error parsing variant map:', e);
        window.location.href = targetUrl;
      }
    }
    
    colorProductLinks.forEach(function(radio, index) {
      const productUrl = radio.getAttribute('data-product-url');
      const variantMap = radio.getAttribute('data-variant-map');
      
      console.log('🎨 Link', index + 1, ':', productUrl);
      
      // Change event
      radio.addEventListener('change', function(e) {
        const url = this.getAttribute('data-product-url');
        const currentPath = window.location.pathname;
        const map = this.getAttribute('data-variant-map');
        
        console.log('🎨 Change event triggered');
        console.log('🎨 Current path:', currentPath);
        console.log('🎨 Target URL:', url);
        
        // Only navigate if it's a different product
        if (url && url !== currentPath) {
          console.log('🎨 Navigating with size preservation');
          
          // Add loading state
          if (switcher) {
            switcher.classList.add('is-loading');
          }
          
          // Navigate with size preservation
          navigateToProductWithSize(url, map);
        } else {
          console.log('🎨 Same product, not navigating');
        }
      });
      
      // Click event (for immediate feedback)
      radio.addEventListener('click', function(e) {
        const url = this.getAttribute('data-product-url');
        const currentPath = window.location.pathname;
        const map = this.getAttribute('data-variant-map');
        
        console.log('🎨 Click event triggered on:', url);
        
        // If clicking a different product, navigate immediately
        if (url && url !== currentPath && !this.checked) {
          console.log('🎨 Navigating immediately via click');
          e.preventDefault();
          
          // Add loading state
          if (switcher) {
            switcher.classList.add('is-loading');
          }
          
          // Navigate with size preservation
          navigateToProductWithSize(url, map);
        }
      });
      
      // Label click (backup)
      const label = document.querySelector('label[for="' + radio.id + '"]');
      if (label) {
        label.addEventListener('click', function(e) {
          const url = radio.getAttribute('data-product-url');
          const currentPath = window.location.pathname;
          const map = radio.getAttribute('data-variant-map');
          
          console.log('🎨 Label clicked for:', url);
          
          if (url && url !== currentPath) {
            console.log('🎨 Navigating via label click with size');
            e.preventDefault();
            
            // Add loading state
            if (switcher) {
              switcher.classList.add('is-loading');
            }
            
            // Navigate with size preservation
            navigateToProductWithSize(url, map);
          }
        });
      }
    });
    
    console.log('🎨 Color Product Switcher: Initialized successfully');
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorProductSwitcher);
  } else {
    initColorProductSwitcher();
  }

  // Re-initialize if content is dynamically loaded
  document.addEventListener('shopify:section:load', function() {
    initColorProductSwitcher();
  });

})();


// Convert the right-column meta blocks (Material / Sizing / Care) into
// a single horizontal tab strip. Sources stay rendered as accordions, so
// if JS fails the user still gets a working accordion fallback.
(function() {
  function mountMetaTabs() {
    var roots = document.querySelectorAll('.product-single__meta');
    if (!roots.length) return;
    roots.forEach(function(root) {
      if (root.dataset.metaTabsWired === '1') return;
      var sources = root.querySelectorAll('.js-meta-tab-source');
      if (sources.length < 2) {
        // Not enough sources to justify tabs — show whatever is there as accordion(s)
        Array.prototype.forEach.call(sources, function(s) {
          s.classList.add('is-fallback');
        });
        root.dataset.metaTabsWired = '1';
        return;
      }
      root.dataset.metaTabsWired = '1';
      root.classList.add('product-meta-tabs-mounted');

      var first = sources[0];
      var container = document.createElement('div');
      container.className = 'product-meta-tabs product-block';

      var nav = document.createElement('div');
      nav.className = 'product-meta-tabs__nav';
      nav.setAttribute('role', 'tablist');

      var panels = document.createElement('div');
      panels.className = 'product-meta-tabs__panels';

      Array.prototype.forEach.call(sources, function(src, i) {
        var key = src.getAttribute('data-meta-key') || ('tab-' + i);
        var label = src.getAttribute('data-meta-label') || '';
        var iconEl = src.querySelector('.tabcustom .icon');
        var bodyEl = src.querySelector('.collapse .py-3');

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-meta-tabs__btn' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('data-target', key);
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.innerHTML =
          (iconEl ? '<span class="product-meta-tabs__icon">' + iconEl.outerHTML + '</span>' : '') +
          '<span class="product-meta-tabs__label">' + label + '</span>';
        nav.appendChild(btn);

        var panel = document.createElement('div');
        panel.className = 'product-meta-tabs__panel' + (i === 0 ? ' is-active' : '');
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('data-key', key);
        if (bodyEl) panel.appendChild(bodyEl);
        panels.appendChild(panel);
      });

      container.appendChild(nav);
      container.appendChild(panels);
      first.parentNode.insertBefore(container, first);
      Array.prototype.forEach.call(sources, function(src) {
        src.parentNode.removeChild(src);
      });

      // Underline indicator that slides between active tabs
      var indicator = document.createElement('span');
      indicator.className = 'product-meta-tabs__indicator';
      nav.appendChild(indicator);
      function moveIndicator(btn) {
        if (!btn) return;
        indicator.style.width = btn.offsetWidth + 'px';
        indicator.style.transform = 'translateX(' + btn.offsetLeft + 'px)';
      }
      function moveActive() {
        moveIndicator(nav.querySelector('.product-meta-tabs__btn.is-active'));
      }
      moveActive();
      // Recompute after fonts load so the underline aligns with the swapped metric
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(moveActive);
      }
      setTimeout(moveActive, 250);
      window.addEventListener('resize', moveActive);

      nav.addEventListener('click', function(e) {
        var btn = e.target.closest && e.target.closest('.product-meta-tabs__btn');
        if (!btn) return;
        var target = btn.getAttribute('data-target');
        Array.prototype.forEach.call(nav.querySelectorAll('.product-meta-tabs__btn'), function(b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        Array.prototype.forEach.call(panels.querySelectorAll('.product-meta-tabs__panel'), function(p) {
          var on = p.getAttribute('data-key') === target;
          if (on) {
            // restart fade animation
            p.classList.remove('is-active');
            void p.offsetWidth;
            p.classList.add('is-active');
          } else {
            p.classList.remove('is-active');
          }
        });
        moveIndicator(btn);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountMetaTabs);
  } else {
    mountMetaTabs();
  }
  document.addEventListener('shopify:section:load', mountMetaTabs);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
